// Мови, за якими групуються учні/вчителі/пробні в кабінеті адміна з доступом "all".
// Зараз школа веде тільки англійську; інші мови додати сюди, коли з'являться.
export const langs = [
   { key: "en", value: "English" },
 ];
